import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  Main,
  HeaderContainer,
  StyledTable,
  TableHead,
  TableBody,
  TableRow,
  ListHeadRow,
  ScrolledBody,
  ThDefault,
  ThLicenseHead,
  TdDefault,
  TdDefaultError,
  TdLicenseHead,
} from './styles/CompanyListsStyles';

const RoleColumns = {
  2: [
    'licenseNumber',
    'voiceAutoAnalysis',
    'ocrAutoAnalysis',
    'remoteSupport',
    'storage',
  ],
  10: [
    'licenseNumber',
    'voiceAutoAnalysis',
    'ocrAutoAnalysis',
    'remoteSupport',
    'storage',
  ],
  20: [
    'activated',
    'licenseNumber',
    'voiceAnalysis',
    'ocr',
    'remoteSupport',
    'storage',
    'type',
  ],
  90: ['activated', 'childrenNumber'],
};

const displayColumn = (role, column) => {
  const columns = RoleColumns[role] || [];
  return columns.indexOf(column) !== -1;
};

const createHeader = role => (
  <ListHeadRow>
    <ThDefault>
      <FormattedMessage id="company.CompanyLists.title.companyCode" />
    </ThDefault>
    <ThDefault>
      <FormattedMessage id="company.CompanyLists.title.companyName" />
    </ThDefault>
    {displayColumn(role, 'activated') && (
      <ThDefault>
        <FormattedMessage id="company.CompanyLists.title.activated" />
      </ThDefault>
    )}
    {displayColumn(role, 'childrenNumber') && (
      <ThDefault width="100">
        <FormattedMessage id="company.CompanyLists.title.childrenNumber" />
      </ThDefault>
    )}
    {displayColumn(role, 'licenseNumber') && (
      <ThDefault width="100">
        <FormattedMessage id="company.CompanyLists.title.licenseNumber" />
      </ThDefault>
    )}
    {displayColumn(role, 'remoteSupport') && (
      <ThLicenseHead>
        <FormattedMessage id="company.CompanyLists.title.remoteSupport" />
      </ThLicenseHead>
    )}
    {displayColumn(role, 'storage') && (
      <ThDefault width="100">
        <FormattedMessage id="company.CompanyLists.title.storage" />
      </ThDefault>
    )}
    {displayColumn(role, 'type') && (
      <ThDefault width="100">
        <FormattedMessage id="company.CompanyLists.title.companyType" />
      </ThDefault>
    )}
  </ListHeadRow>
);

const storageType = [
  <FormattedMessage id="company.CompanyLists.title.storageType.0" />,
  <FormattedMessage id="company.CompanyLists.title.storageType.1" />,
  <FormattedMessage id="company.CompanyLists.title.storageType.2" />,
  <FormattedMessage id="company.CompanyLists.title.storageType.3" />,
];

const createList = (idx, list, onSelect, role) => {
  const onClickCompany = `onClickCompany${idx}`;
  const { usedNumber, contractNumber, licenseCapacityStatus } =
    list.userLicense;
  const storageLicenseCapacityStatus =
    list.storageLicense.licenseCapacityStatus;
  const remoteSupportLicenseCapacityStatus =
    list.remoteSupportLicense.licenseCapacityStatus;
  const remoteSupportLicenseEnabled = list.remoteSupportLicense.enabled
    ? 'ON'
    : 'OFF';
  const displayAccount = `${usedNumber}/${contractNumber}`;
  const activatedMessageId =
    (list.activatedAt && 'company.CompanyLists.title.activated.activated') ||
    'company.CompanyLists.title.activated.notActivated';
  const ciosv2Company = !!list.activationCode;
  return (
    <TableRow
      className="clickableItem"
      id={onClickCompany}
      key={onClickCompany}
      onClick={() => {
        onSelect(list.companyId);
      }}
    >
      <TdDefault>{list.companyCode}</TdDefault>
      <TdDefault>{list.companyName}</TdDefault>
      {displayColumn(role, 'activated') && (
        <TdDefault>
          {(ciosv2Company && <FormattedMessage id={activatedMessageId} />) ||
            '--'}
        </TdDefault>
      )}
      {displayColumn(role, 'childrenNumber') && (
        <TdDefault width="100">{list.childrenNumber || ''}</TdDefault>
      )}
      {displayColumn(role, 'licenseNumber') && (
        <TdDefaultError width="100" error={licenseCapacityStatus === 3}>
          {displayAccount}
        </TdDefaultError>
      )}
      {displayColumn(role, 'remoteSupport') && (
        <TdLicenseHead error={remoteSupportLicenseCapacityStatus === 3}>
          {remoteSupportLicenseEnabled}
        </TdLicenseHead>
      )}
      {displayColumn(role, 'storage') && (
        <TdDefaultError width="100" error={storageLicenseCapacityStatus === 3}>
          {storageType[list.storageLicense.storageType]}
        </TdDefaultError>
      )}
      {displayColumn(role, 'type') && (
        <TdDefault width="100">{list.companyType}</TdDefault>
      )}
    </TableRow>
  );
};

/**
 * 企業管理一覧表を表示するコンポーネント
 * @param {*}
 * @returns
 */
const CompanyLists = ({ role, companies, onSelect }) => (
  <Main className="CompanyLists">
    <HeaderContainer>
      <StyledTable>
        <TableHead>{createHeader(role)}</TableHead>
      </StyledTable>
    </HeaderContainer>
    <ScrolledBody>
      <StyledTable>
        <TableBody>
          {companies &&
            companies.map((list, idx) => createList(idx, list, onSelect, role))}
        </TableBody>
      </StyledTable>
    </ScrolledBody>
  </Main>
);

CompanyLists.propTypes = {
  role: PropTypes.number.isRequired,
  companies: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default CompanyLists;
